export default "__VITE_ASSET__e8e70df4__"